import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const data = createReducer(
  {},
  {
    [ActionTypes.FETCH_HOMEPAGE_DATA_SUCCESS]: (state, { payload }) => payload
  }
);

const status = createReducer(null, {
  [ActionTypes.FETCH_HOMEPAGE_DATA_SUCCESS]: (_, { type }) => type
});

export default combineReducers({
  data,
  status
});
